<template>
  <div class="bgc score">
    <Loading v-if="loading" />

    <div class="title">
      <div class="sort_son_title">
        {{ itemTitle }}
      </div>
      <div class="right_div">
        <!-- <a-button class="btn" type="primary" ghost @click="visible = true">
          切换考试
        </a-button> -->
        <a-button
          v-if="tableData && tableData.length"
          class="btn"
          type="primary"
          ghost
          @click="importTo"
        >
          {{ $t('exam.downbtn') + itemTitle }}
        </a-button>
      </div>
    </div>
    <div class="table_div">
      <div class="row-tb">
        <div v-if="dList && dList.length == 1" class="echartsA">
          <div class="chartsTitle">
            {{ dList[0].className }}
          </div>
          <div ref="chartA" class="echarts_list"></div>
        </div>
        <div
          class="table-box"
          :class="dList && dList.length == 1 && 'row-table'"
        >
          <Table
            ref="table"
            :columns="columns"
            :pagination="false"
            :data="tableData"
          />
        </div>
      </div>

      <div v-if="dList && dList.length > 1" class="echartsB">
        <div ref="chartB" class="echarts_list"></div>
      </div>
      <!-- <div v-if="showChart" class="echarts">
        <div ref="chart" class="echarts_list"></div>
      </div>
      <a-modal
        v-model="showScore"
        centered
        :mask-closable="true"
        title="层次错因分析"
        class="test_modal"
        :width="1200"
        footer=""
      >
        <label>展示条件：</label>
        <a-select v-model="type" style="width:200px;" @change="getAnalyse">
          <a-select-option
            v-for="item in typeList"
            :key="item.id"
            :value="item.id"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
        <div class="scoreTable">
          <Table :columns="columns2" :pagination="false" :data="tableData2" />
        </div>
      </a-modal> -->
    </div>
  </div>
</template>

<script>
  import axios, { getCookie, strToNumber } from '@utils'
  import ApiXy from '@lib/api.js'
  import Table from '@comp/tables/questionRateTable.vue'
  import * as echarts from 'echarts'
  import Loading from '@comp/loading'

  export default {
    components: {
      Table,
      Loading
    },
    props: {
      id: {
        type: String,
        default: ''
      },
      itemTitle: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        loading: false,
        visible: false,
        // meIds: '',
        type: 1,
        typeList: [
          {
            id: 1,
            name: '按错因展示'
          },
          {
            id: 2,
            name: '按学生展示'
          }
        ],
        showScore: false,
        row: {},
        columns2: [],
        tableData2: [],
        title: '题目层次得分率对比',
        columns: [
          // {
          //   title: '题目',
          //   dataIndex: 'questionIndex',
          //   customRender: (text, row) =>
          //     this.renderFc(text, row, 'questionIndex')
          // },
          // {
          //   title: '班级平均分',
          //   dataIndex: 'classAvg',
          //   customRender: (text, row) => this.renderFc(text, row, 'classAvg')
          // },
          // {
          //   title: '得分率(%)',
          //   dataIndex: 'scoreRate',
          //   customRender: (text, row) => this.renderFc(text, row, 'scoreRate')
          // },
        ],
        columns1: [
          {
            title: this.$t('exam.quesRateColum[0]'),
            dataIndex: 'className'
          },
          {
            title: this.$t('exam.quesRateColum[1]'),
            dataIndex: 'topicHierarchyName'
          }
        ],
        tableData: [],
        query: {},
        chartList: [],
        colorList: [],
        dList: [],
        splitNum: 6,
        dataList: [],
        barColor: [
          '#6496F9',
          '#5E5CE6',
          '#9fe080',
          '#ffdc60',
          '#a969c6',
          '#b37bcd',
          '#ff88e0',
          '#ff915a',
          '#ff7070',
          '#ff88e0',
          '#86d6f5',
          '#40b27d'
        ],
        resData: {},
        dataIndexs: ['aRate', 'bRate', 'cRate', 'dRate'],
        courseInfo: [],
        charts: null
      }
    },
    watch: {
      $route() {
        this.getCompetencylevel()
      }
    },
    created() {
      this.query = this.$route.query
    },
    mounted() {
      this.getCompetencylevel()
      window.addEventListener('resize', this.resizeChart)
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.resizeChart)
    },
    methods: {
      resizeChart() {
        if (this.charts) this.charts.resize()
      },
      renderChart() {
        let dListData = this.dList ? this.dList.length : 0
        if (!dListData) return
        let chartBox = dListData === 1 ? 'chartA' : 'chartB'
        this.charts = echarts.init(this.$refs[chartBox])
        let angleAxis = [] //极坐标系的角度轴
        let radiusAxis = [] //极坐标系的径向轴
        let polar = [] //极坐标系
        let title = [] //班级
        let series = []

        /**调整距离start**/

        let xNumBs = 25 //x轴百分比基数
        let barWh = 100 //坐标图半径大小
        let titleY = 130
        let rowNum = dListData === 1 ? 290 : 340 //初始化一行高度
        /**调整距离end**/

        let yNum = 180 //初始值
        let xNum = dListData == 1 ? 50 : 13 //初始值

        let titleTop = yNum + titleY

        this.dList.forEach((item, index) => {
          angleAxis.push({
            type: 'category',
            data: item.tList.map(itemc => itemc.topicHierarchyName),
            polarIndex: index
          })

          radiusAxis.push({
            polarIndex: index,
            type: 'value'
          })
          if (index) {
            xNum += xNumBs
            if (index % 4 == 0) {
              yNum += rowNum
              xNum = 13
              titleTop = yNum + titleY
            }
          }

          title.push({
            text: item.className,
            left: xNum + '%',
            top: titleTop,
            textAlign: 'center',
            textStyle: {
              fontSize: 14
            }
          })

          polar.push({
            center: [xNum + '%', yNum],
            radius: barWh
          })

          let courseInfoLen = this.courseInfo.length - 1
          for (let c = courseInfoLen; c >= 0; c--) {
            let itemc = this.courseInfo[c]
            let indexc = c
            let data = item.tList.map(itemd => itemd[this.dataIndexs[indexc]])
            series.push({
              type: 'bar',
              data,
              coordinateSystem: 'polar',
              name: itemc.dispoName,
              stack: index + '',
              polarIndex: index
            })
          }
          // this.courseInfo.forEach((itemc, indexc) => {
          //   let data = item.tList.map(itemd => itemd[this.dataIndexs[indexc]])
          //   series.push({
          //     type: 'bar',
          //     data,
          //     coordinateSystem: 'polar',
          //     name: itemc.dispoName,
          //     stack: index + '',
          //     polarIndex: index
          //   })
          // })
        })
        let legendData = this.courseInfo.map(itemc => itemc.dispoName)
        let opColors = ['#6496F9', '#69D4AA', '#FFD995', '#FF8484'].reverse()

        let chartObj = {
          legend: {
            show: true,
            data: legendData,
            top: 12,
            left: 'center',
            itemGap: 10
          },
          color: opColors, //红绿蓝
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
            },
            borderWidth: 0, //设置自定义边框宽度
            backgroundColor: 'none', //设置自定义背景
            extraCssText:
              //额外附加到浮层的css样式，此处为为浮层添加阴影及padding
              'backdrop-filter: blur(10px)',
            formatter: params => {
              //格式化函数
              // let strArr = []
              let konwName = ''
              params.reverse().forEach((item, index) => {
                let data = item.data
                let seriesName = dListData === 1 ? '' : item.seriesName + ' : '
                konwName +=
                  `${
                    !index
                      ? `<div style='font-weight: 500;line-height: 20px;color: @text-color-secondary;'>${item.name}</div>`
                      : ''
                  }` +
                  `<div class="toolTip">${item.marker}${seriesName}` +
                  `${isNaN(+data) ? data : data + '%'}</div>`
              })
              return konwName
            }
          },
          title,
          angleAxis,
          radiusAxis,
          polar,
          series
        }
        this.charts.clear()
        this.charts.setOption(chartObj)
        let height = Math.ceil(this.dList.length / 4) * rowNum + 20
        this.charts.resize({ height })
      },
      beforeEchart(data) {
        let top
        if (data.legend && data.legend.data) {
          let baseNum = Math.ceil(data.legend.data.length / 10)
          top = baseNum * 40 + 24
        }
        //echarts距离处理
        data.grid = {
          top: data.legend ? top : 24,
          bottom: 28,
          left: '3.5%',
          right: '3.5%'
        }
        //x轴处理
        if (Array.isArray(data.xAxis)) {
          data.xAxis.forEach(item => {
            xDataDispose(item)
          })
        } else {
          xDataDispose(data.xAxis)
        }
        //x轴数据处理
        function xDataDispose(xData) {
          if (!xData.axisLabel) xData.axisLabel = {}
          xData.axisLabel.textStyle = {
            fontFamily: 'PingFangSC, PingFangSC-Regular',
            color: '#666666',
            fontSize: 14
          }
          xData.axisTick = {
            show: false
          }
          !xData.offset && (xData.offset = 4)
          if (!xData.axisLine) {
            xData.axisLine = {
              show: true,
              lineStyle: {
                color: '#5F8EEC'
              }
            }
          }
        }

        //Y轴处理
        if (!data.yAxis) data.yAxis = {}
        if (Array.isArray(data.yAxis)) {
          data.yAxis.forEach(item => {
            yDataDispose(item)
          })
        } else {
          yDataDispose(data.yAxis)
        }
        //y轴数据处理
        function yDataDispose(yData) {
          if (!yData.splitLine) {
            yData.splitLine = {
              show: false
            }
          }

          if (!yData.axisLabel) yData.axisLabel = {}
          yData.axisLabel.textStyle = {
            fontFamily: 'PingFangSC, PingFangSC-Regular',
            color: '#666666',
            fontSize: 12
          }
          if (!yData.axisLine) {
            yData.axisLine = {
              show: true,
              lineStyle: {
                color: '#5F8EEC'
              },
              itemStyle: {
                color: '#666666'
              }
            }
          }
          if (!yData.splitArea) {
            yData.splitArea = {
              show: true,
              areaStyle: {
                color: ['#A78BFA', '#fff'],
                opacity: 0.04
              }
            }
          }
        }
      },
      //图表滚动条
      cScroll(data, xTitle, num) {
        //如果超过num个则显示滚动条
        if (xTitle.length >= num) {
          let endVal = num === 1 ? 5 : +(100 * (num / xTitle.length)).toFixed(2)
          data.grid.bottom = 64
          data.dataZoom = [
            {
              start: 0, //默认为0
              end: endVal, //默认为100
              type: 'slider',
              show: true,
              xAxisIndex: [0],
              handleIcon: `M 100, 100
                                  m -75, 0
                                  a 75,75 0 1,0 150,0
                                  a 75,75 0 1,0 -150,0`,
              handleSize: '85%',
              handleStyle: {
                color: '#ddeeff',
                borderWidth: 0
              },
              moveHandleSize: 0, //移动手柄尺寸高度
              height: 8, //组件高度
              left: 40, //左边的距离
              right: 40, //右边的距离
              bottom: 14, //底部的距离
              fillerColor: '#ddeeff', //线条颜色
              borderColor: 'transparent', //线条边框颜色
              backgroundColor: '#F8F8F8', //两边未选中的滑动条区域的颜色
              showDataShadow: false, //是否显示数据阴影 默认auto
              showDetail: false, //即拖拽时候是否显示详细数值信息 默认true
              realtime: true, //是否实时更新
              filterMode: 'filter',
              brushSelect: false //关闭十字架选中
            }
          ]
        }
      },
      renderFc(text, row, dataIndex, bol) {
        let isScore = row.isScoreMin !== row.isScoreMax
        let min = isScore && row.isScoreMin ? 'score minScore' : ''
        let max = isScore && row.isScoreMax ? 'score maxScore' : ''
        let min1 = row.isMin ? 'score1 minScore1' : ''
        let max1 = row.isMax ? 'score1 maxScore1' : ''
        let className = ''
        if (dataIndex === 'scoreRate') {
          className = min ? min : max ? max : min1 ? min1 : max1
        } else {
          className = min1 ? min1 : max1
        }
        if (bol) return className
        return <span class={className}>{text}</span>
      },
      showModal(row) {
        this.showScore = true
        this.row = { ...row }
        // 获取得分明细表格
        this.getAnalyse()
      },
      getAnalyse() {
        this.columns2 = []
        let { classId, topicHierarchyId } = this.row
        let url = this.type == 1 ? 'anabyreason' : 'anabystudent'
        let params = {
          seId: this.$route.query.seId,
          classId,
          topicHierarchyId,
          campusId: this.$route.query.campusId
        }
        axios({
          url,
          params,
          loading: true
        }).then(res => {
          console.log(res, '---res dfldb---')
          if (res.status && res.data) {
            res.titles.forEach((item, i) => {
              if (i == 0) {
                this.columns2.push({
                  title: item.title,
                  dataIndex: 'reason' + i,
                  width: 100,
                  fixed: 'left'
                })
              } else {
                this.columns2.push({
                  title: item.title,
                  dataIndex: 'reason' + i,
                  width: 100
                })
              }
            })
            let arr = [{}]
            res.data.forEach((ele, i) => {
              arr[i] = {}
              ele.forEach((item, j) => {
                arr[i]['reason' + j] = item
              })
            })
            this.tableData2 = arr
          } else {
            this.tableData2 = []
          }
        })
      },
      getCompetencylevel() {
        let dataLength = 0
        this.loading = true
        let { seId, subjectId, classId, meId, campusId } = this.$route.query
        let params = {
          meId,
          seId,
          subjectId,
          // meIds: this.meIds,
          classId,
          campusId
        }
        axios({
          url: 'competencylevelcompbyseids',
          params,
          loading: false
        })
          .then(res => {
            this.loading = false
            this.courseInfo = res.courseInfo || []
            /**不改变以往结构处理**/
            let data = res.data || []
            data = data.map(item => {
              item.tList = item.tList.map(itemc => {
                // //测试
                // itemc.topicHierarchyScore = ['70', '20']
                // //测试

                let valueData = []
                this.courseInfo.forEach(itemd => {
                  let status = itemc.topicHierarchyScore[itemd.seId]
                  if (status === undefined) {
                    itemc.topicHierarchyScore[itemd.seId] = '--'
                  }
                  valueData.push(itemc.topicHierarchyScore[itemd.seId])
                })

                valueData.forEach((itemd, indexd) => {
                  itemc[this.dataIndexs[indexd]] = itemd
                })
                return itemc
              })
              return item
            })

            this.dataList = JSON.parse(JSON.stringify(data))

            this.resData = JSON.parse(JSON.stringify(res))

            res.data = data.map(item => {
              item.tList = item.tList.map(itemc => {
                if (!itemc.dList) itemc.dList = [{}]
                return itemc
              })
              return item
            })
            /**处理End**/
            this.dList = JSON.parse(JSON.stringify(res.data))

            let strNum = this.dList.length == 1 ? 12 : 24
            let lastCol = []
            this.courseInfo.forEach((item, index) => {
              let nameStr = item.alias ? item.alias : item.seName
              let examName = nameStr.substring(nameStr.length - strNum)
              let fristSym = examName.length !== nameStr.length ? '...' : ''
              item.dispoName = fristSym + examName
              let obj = {
                title: () => {
                  return (
                    <div class="textOverflow" title={nameStr}>
                      {item.dispoName}
                      <div>{this.$t('exam.qusth')}</div>
                    </div>
                  )
                },
                dataIndex: this.dataIndexs[index]
              }
              lastCol.push(obj)
            })
            this.columns = this.columns1.concat(lastCol)

            //图表数据
            let chartData = []
            //表格合并
            let colData = {
              classCol: 0,
              questionCol: 0,
              classIdx: 0,
              questionIdx: 0
            }
            let resData = []
            res.data &&
              res.data.forEach((item, index) => {
                // 班级循环
                colData.classCol = 0
                let tList = JSON.parse(JSON.stringify(item.tList)) || []
                delete item.tList
                let obj = item
                // 层次排序
                // let sortlist = tList.sort(
                //   (a, b) =>
                //     a.topicHierarchyScore * 1 - b.topicHierarchyScore * 1
                // )
                tList.forEach(itemc => {
                  // 层次循环
                  colData.questionCol = 0
                  for (let i in itemc) {
                    this.checkNumber(item[i]) && (item[i] = +item[i])
                  }
                  // 层次内的小题分 排序
                  // let sortquesList = itemc.dList.sort(
                  //   (a, b) => a.scoreRate * 1 - b.scoreRate * 1
                  // )
                  // 表示层次内小题分的最高和最低
                  // for (let c in itemc.dList) {
                  //   if (
                  //     itemc.dList[c] == sortquesList[0] &&
                  //     itemc.dList[c].scoreRate
                  //   ) {
                  //     itemc.dList[c].isScoreMin = true
                  //   }
                  //   if (
                  //     itemc.dList[c] == sortquesList[sortquesList.length - 1] &&
                  //     itemc.dList[c].scoreRate
                  //   ) {
                  //     itemc.dList[c].isScoreMax = true
                  //   }
                  // }
                  // if (itemc === sortlist[0]) {
                  //   itemc.isMin = true
                  //   for (let a in itemc.dList) {
                  //     itemc.dList[a].isMin = true
                  //   }
                  // } // 层次最低
                  // if (itemc === sortlist[sortlist.length - 1]) {
                  //   itemc.isMax = true
                  //   for (let a in itemc.dList) {
                  //     itemc.dList[a].isMax = true
                  //   }
                  // } // 层次最高
                  itemc.topicHierarchyScore = strToNumber(
                    itemc.topicHierarchyScore
                  )
                  let dList = JSON.parse(JSON.stringify(itemc.dList)) || []
                  delete itemc.dList
                  let objc = {
                    ...obj,
                    ...itemc
                  }
                  /** charts数据处理start **/
                  if (index === 0) {
                    let chartObj = {
                      name: itemc.topicHierarchyName,
                      id: itemc.topicHierarchyId,
                      data: [{ ...obj, ...itemc }]
                    }
                    chartData.push(chartObj)
                  } else {
                    chartData.forEach((ct, idx) => {
                      if (ct.id === itemc.topicHierarchyId) {
                        chartData[idx].data.push({ ...obj, ...itemc })
                      }
                    })
                  }
                  /**charts数据处理end**/
                  dList.forEach(itemd => {
                    colData.classCol++
                    colData.questionCol++
                    itemd.scoreRate = +itemd.scoreRate
                    for (let i in itemd) {
                      this.checkNumber(item[i]) && (item[i] = +item[i])
                    }
                    resData.push({
                      ...objc,
                      ...itemd
                    })
                  })
                  resData[colData.questionIdx].questionSpan =
                    colData.questionCol
                  colData.questionIdx = resData.length
                })
                dataLength += colData.classCol
                resData[colData.classIdx] &&
                  (resData[colData.classIdx].classSpan = colData.classCol)
                colData.classIdx = resData.length
              })
            if (dataLength > 13) {
              this.$refs.table.height = 600
            } else {
              this.$refs.table.height = 0
            }
            this.columns = this.columns.map(cItem => {
              if (cItem.dataIndex === 'className') {
                cItem.customRender = (value, row) => {
                  const obj = {
                    children: value,
                    attrs: {}
                  }
                  obj.attrs.rowSpan =
                    row.classSpan == 1 ? null : row.classSpan || 0
                  return obj
                }
              }
              if (['topicHierarchyName'].includes(cItem.dataIndex)) {
                cItem.customRender = (value, row) => {
                  const obj = {
                    children: this.renderFc(value, row, cItem.dataIndex),
                    attrs: {}
                  }
                  obj.attrs.rowSpan =
                    row.questionSpan == 1 ? null : row.questionSpan || 0
                  return obj
                }
              }
              return cItem
            })
            this.tableData = resData
            this.chartList = chartData

            //渲染图表
            this.$nextTick(() => {
              this.renderChart()
            })
          })
          .catch(() => {
            setTimeout(() => {
              this.loading = false
            }, 200)
          })
      },
      //数字检测
      checkNumber(val) {
        let reg = /^\d+(.\d+)?$/
        return reg.test(val)
      },
      getColorRandom() {
        let cStr = () => {
          let num = parseInt(Math.random() * 255) || 1
          let str = parseInt(num, 10).toString(16)
          return str.repeat(str.length > 1 ? 1 : 2)
        }
        let colorStr = '#' + cStr() + cStr() + cStr()
        return colorStr
      },
      importTo() {
        let url =
          `${ApiXy.defaulteApi.host}` +
          `${ApiXy.defaulteApi.path.competencylevelcompbyseidsexport}` +
          '?campusId=' +
          this.$route.query.campusId +
          '&seId=' +
          this.$route.query.seId +
          '&subjectId=' +
          this.$route.query.subjectId +
          '&classId=' +
          this.$route.query.classId +
          '&X-ZYLX-TOKEN=' +
          getCookie('X-ZYLX-TOKEN')
        window.open(url, '_blank', '')
      }
    }
  }
</script>

<style lang="less" scoped>
  /deep/.toolTip {
    height: 32px;
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 6px 0px 20px 0px rgba(34, 87, 188, 0.1);
    border-radius: @border-radius-base;
    margin: 2px 0;
    padding: 0 8px;
    line-height: 32px;
  }
  .score {
    height: 100%;
    .title {
      .left_div {
        margin-left: @padding-lg;
      }
      .right_div {
        margin-right: @padding-lg;
        .btn {
          margin-left: @padding-sm;
        }
      }
    }
    .table_div {
      height: calc(100% - 58px);
      padding: 20px;
      .echartName {
        padding: 0 10%;
        text-align: center;
        font-size: @font-size-lg;
        font-weight: bold;
      }
      /deep/ .ant-table-body {
        border-top: @border-width-base solid #e8e8e8;
        border-bottom: @border-width-base solid #e8e8e8;
        max-width: 100%;
        // max-height: 65vh;
        overflow-x: auto;
        overflow-y: auto;
        &:hover::-webkit-scrollbar-thumb {
          visibility: visible;
        }
        table {
          border-top: 0;
          .ant-table-row-cell-ellipsis {
            width: 120px;
          }
          .scoreRate {
            cursor: pointer;
            color: @primary-color;
            .rate_icon {
              display: inline-block;
              width: 7px;
              height: @padding-sm;
              line-height: @padding-sm;
              margin-left: 6px;
            }
          }
        }
      }
    }
  }

  .chartText {
    display: inline-block;
    opacity: 0;
  }
  .scoreTable {
    margin-top: 20px;
    max-height: 600px;
    overflow: auto;
  }

  .select-box {
    padding: 40px 38px 20px;
    text-align: right;
  }
  .row-tb {
    display: flex;
  }

  .echartsA {
    display: flex;
    flex-direction: column;
    min-width: 400px;
    margin-right: 14px;
    border: 1px solid #e8e8e8;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    overflow: hidden;
    .chartsTitle {
      width: 100%;
      height: 66px;
      background: #f4f4f4;
      color: #333;
      font-size: 14px;
      font-weight: 500;
      line-height: 67px;
      text-align: center;
    }
  }

  .echartsB {
    margin-top: 30px;
  }
  .echarts_list {
    width: 100%;
    max-height: 700px;
    overflow-y: auto;
    overflow-x: hidden;
    margin-bottom: 32px;
    &:hover::-webkit-scrollbar-thumb {
      visibility: visible;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }

  .table-box {
    width: 100%;
    display: flex;
    .table-comp {
      width: 100%;
    }
  }
  .row-table {
    /deep/ .ant-table table {
      height: 378px !important;
    }
  }
  .textOverflow {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
